import ListTransform from '@model/list/ListTransform'
import Locale from '@serv/Locale'

class ListTransformCarePeriodType extends ListTransform {
    constructor(object) {
        if (object.column.eventType) {
            object.filterKey = `carePeriodType${object.column.eventType}`
        } else {
            object.filterKey = 'carePeriodPeriodType'
        }

        super(object)
    }

    get getFilterConfig() {
        if (!this.column?.valueFilterOptions) {
            return
        }

        const optionPrefixLen = 'periodType'.length
        const valueLabels = this.column.valueFilterOptions.map(option => {
            const value = option.charAt(optionPrefixLen).toLowerCase() + option.slice(optionPrefixLen + 1)
            const text = Locale.getLanguageItem(option)

            return { value: value, label: text }
        })

        return {
            title: Locale.getLanguageItem(this.column.label),
            valueLabels: this.column.sortValueLabels(valueLabels),
            addAll: true
        }
    }

    getQueryParamValueFromKeyStrings(keyStrings) {
        const filterValue = keyStrings.length > 0 ? keyStrings[0] : undefined
        if (!filterValue) {
            return
        }

        return { values: [filterValue], eventType: this.column.eventType ? this.column.eventType : undefined }
    }
}

export default ListTransformCarePeriodType
